import type { NextTarget } from "@/utils/nextPath";
import type { Href } from "expo-router";

/** Where a login lands when no valid `next` was given. */
export const DEFAULT_NEXT_HREF: Href = { pathname: "/app" };

/**
 * The typed route of a `next` target. Built from the parsed pieces, never from the
 * raw string, so only the allow-listed routes can ever be produced.
 */
export const hrefForNext = (target: NextTarget | null): Href => {
  switch (target?.kind) {
    case "claim":
      return { pathname: "/start/claim" };
    case "applications":
      return {
        pathname:
          "/app/(brands)/[brandId]/(main)/campaign/[campaignId]/applications",
        params: { brandId: target.brandId, campaignId: target.campaignId },
      };
    case "agentChat":
      return {
        pathname: "/app/(brands)/[brandId]/(main)/campaign/ai",
        params: { brandId: target.brandId, sessionId: target.sessionId },
      };
    case "contentApprovals":
      return {
        pathname: "/app/(brands)/[brandId]/(main)/contentApprovals",
        params: { brandId: target.brandId },
      };
    default:
      return DEFAULT_NEXT_HREF;
  }
};
